import React from "react";

import { Category, Option } from "Components/AppGrid/shipeezi-new-grid";
import { AutoSuggest } from "Components/Form";
import { useTranslation } from "react-i18next";

interface Props {
  filter: Category;
  onSelectOption: (option: string, checked: boolean) => void;
  onAddOption: (option: Option) => void;
}

const AutoSuggestFilter = (props: Props) => {
  const { filter, onSelectOption, onAddOption } = props;
  const { t: translate } = useTranslation();

  const { optionColumn: column = "id", multiple = false } = filter;

  if (!filter?.column) return null;

  const isColumnNone = column === "none";
  const handleChangeFilters = (options: any) => {
    for (const option of options) {
      const value = isColumnNone ? option : option[column];
      const label = filter?.getOptionLabel ? filter.getOptionLabel(option) : value;

      onAddOption({ value, label });
    }
  };

  return (
    <AutoSuggest
      tagDataCy={`item-${filter.name}-filter-by`}
      dataCy={`${filter.name}-filter-by-select`}
      onSearch={filter.onSearch}
      placeholder={filter?.name ? `${translate("typeIn")} ${filter.name.toLowerCase()}` : ""}
      multiple
      getOptionLabel={filter.getOptionLabel}
      value={[]}
      getOptionSelected={(option, value: any) => {
        if (!isColumnNone) return option?.[column] === value?.[column];

        return option === value;
      }}
      onChange={(options) => {
        const newOptionsSelected =
          multiple === false && options.lenght ? [options[options.length - 1]] : options;

        onSelectOption(newOptionsSelected, true);

        handleChangeFilters(newOptionsSelected);
      }}
    />
  );
};

export default AutoSuggestFilter;
